/**
 * Recursively loads folder children from FileEndpoints-style API and merges into React folder state.
 * Shared by Insights and Support to avoid duplicated fetch/setFolders logic.
 */
export function fetchFolderChildrenRecursive(folder, { getFiles, setFolders, onError }) {
  return getFiles(folder.fileId, null, null)
    .then(({ data }) => {
      folder.children = data.sort((a, b) => a.order - b.order)

      setFolders((prevFolders) => {
        const updatedFolders = [...prevFolders]
        const folderIndex = updatedFolders.findIndex((f) => f.fileId === folder.fileId)
        if (folderIndex !== -1) {
          updatedFolders[folderIndex] = folder
        }
        return updatedFolders
      })

      if (folder.children && folder.children.length) {
        const childPromises = folder.children.map((child) =>
          child.isFolder ? fetchFolderChildrenRecursive(child, { getFiles, setFolders, onError }) : Promise.resolve()
        )
        return Promise.all(childPromises)
      }
      return Promise.resolve()
    })
    .catch((error) => {
      if (onError) onError(error)
      else console.error('Error fetching folder children:', error)
    })
}
